import ImagesSlider from '../components/imagesSlider'

class ImagesSliders {
	components: ImagesSlider[] = []

	init(container: Document | HTMLElement = document) {
		container.querySelectorAll<HTMLElement>('.hg-images-slider').forEach((el) => {
			const component = new ImagesSlider(el)
			component.init()
			this.components.push(component)
		})
	}

	update(container: Document | HTMLElement = document) {
		this.cleanup()
		this.init(container)
	}

	cleanup() {
		this.components.forEach((c) => c.cleanup())
		this.components = []
	}
}

export default new ImagesSliders()
